import { S25Util } from "../../util/s25-util";
import { EventMircotI, WSReservations } from "../s25-event/EventMicroI";
import { S25WsNode } from "../../pojo/S25WsNode";
import { S25WsSpace } from "../../services/space.service";
import { S25WsResource } from "../../services/resource.service";
import { S25Profile } from "../s25-event/ProfileI";
import { ObjectType, S25Reservation } from "../s25-event/ReservationI";
import { ResourceSpaceAvailService } from "../../services/resource.space.avail.service";
import { jSith } from "../../util/jquery-replacement";
import { Item } from "../../pojo/Item";
import { Event } from "../../pojo/Event";
import Rsrv = Event.Reservation.States;

import Reservation = AvailCheck.Reservation;
import SpaceReservation = AvailCheck.SpaceReservation;
import { AvailCheck } from "../../pojo/AvailabilityCheck";
import CheckedObj = AvailCheck.CheckedObj;
import { ObjectSearchAvailabilityUtil } from "../../util/object.search.availability.util";
import ConflictDefaults = AvailCheck.ConflictDefaults;
import ResourceReservation = AvailCheck.ResourceReservation;
import CheckedItem = AvailCheck.CheckedItem;

export class S25ObjectSearchUtil {
    public static async getAvailData(
        objectType: ObjectType,
        profileId: number,
        eventId: number,
        accumItems: any,
        event: EventMircotI,
        selectedItems: number[],
        newProfile: S25Profile,
    ) {
        if (newProfile) {
            const findProfile = event.profile.find((p: S25Profile) => p.itemId === newProfile.itemId);
            if (!findProfile) event.profile.push(newProfile);
        }
        let reservations = await S25ObjectSearchUtil.normalizeReservationData(objectType, accumItems, profileId, event);
        let specificOccs: any[] = reservations.filter((item: any) => selectedItems.includes(item.rsrv));
        return ResourceSpaceAvailService.checkAvailability(eventId, profileId, specificOccs, true).then(function (
            data: any,
        ) {
            return S25ObjectSearchUtil.checkedObj(accumItems, data, specificOccs);
        });
    }

    public static async normalizeReservationData(
        objectType: ObjectType,
        accumItems: SpaceReservation[] | ResourceReservation[],
        profileId: number,
        event: EventMircotI,
    ) {
        let findProfile = event.profile.find((p: S25Profile) => {
            return p?.itemId === profileId;
        });
        let reservations: Reservation[] = [];

        if (findProfile?.reservations) {
            let count = 0;
            let space_reservation: SpaceReservation[] = [];
            let resource_reservation: ResourceReservation[] = [];
            if (objectType === "location") {
                space_reservation = accumItems.map((item: any) => {
                    return {
                        space_id: item.space_id,
                        share: item.share,
                        always_shared: item.always_shared, // Assuming always_shared is "F" as there is no equivalent property in the input data
                        conflicts: [],
                    } as SpaceReservation;
                });
            }

            if (objectType === "resource") {
                resource_reservation = accumItems.map((item: any) => {
                    return {
                        resource_id: item.resource_id,
                        quantity: 1,
                        conflicts: [],
                    } as ResourceReservation;
                });
            }

            findProfile?.reservations.forEach((r: S25Reservation) => {
                if (r.state !== Rsrv.Cancelled) {
                    let rsrv: Reservation = {
                        occUUID: count++,
                        reservation_start_dt: r?.setupStart || r?.preEventStart || r.eventStart,
                        reservation_end_dt: r?.takeDownEnd || r?.postEventEnd || r.eventEnd,
                        space_reservation: space_reservation,
                        resource_reservation: resource_reservation,
                        rsrv: r.itemId,
                        state: { itemId: 1, itemName: "Active" },
                    };
                    reservations.push(rsrv);
                }
            });
        }
        return reservations;
    }

    public static checkedObj(
        accumItems: (SpaceReservation | ResourceReservation)[],
        reservations: any,
        specificOccs: any[],
    ): CheckedItem[] {
        let numDatesToCheck: number = specificOccs.length;
        let itemTypeId = reservations.resourceConflicts[0]?.itemTypeId || reservations?.spaceConflicts[0]?.itemTypeId;
        let checkedItems = reservations.spaceConflicts;
        if (itemTypeId === Item.Ids.Resource) checkedItems = reservations.resourceConflicts;

        jSith.forEach(accumItems, function (_, itm) {
            const item = itm as (SpaceReservation | ResourceReservation) & CheckedItem;
            item.checkedObj = {
                conflicts: [],
                hasConflicts: false,
                hasRealConflicts: false,
                totalDatesChecked: numDatesToCheck,
                availableDates: numDatesToCheck,
                conflictingDates: 0,
                availableDatesWithOverrides: numDatesToCheck,
            };
            item.apRestriction = undefined;

            jSith.forEach(checkedItems, function (_, rsrv) {
                if (itemTypeId === Item.Ids.Location) {
                    if (
                        item.itemId === parseInt(rsrv.itemId) &&
                        rsrv.apNoRequest &&
                        S25Util.date.equal(
                            S25Util.date.dropTZString(rsrv.apViolationDate),
                            S25Util.date.dropTZString(rsrv.candidateDate),
                        )
                    ) {
                        item.apRestriction = {
                            startDt: rsrv?.apViolationDate,
                            apNoRequest: true,
                            reason: rsrv.apReason,
                        };
                    }

                    if (item.itemId === parseInt(rsrv.itemId)) {
                        const findDateExit = item.checkedObj.conflicts.find(
                            (i: any) => i.itemId === parseInt(rsrv.itemId) && i.candidateDate === rsrv.candidateDate,
                        );
                        if (!findDateExit) item.checkedObj.availableDates -= 1;
                        S25ObjectSearchUtil.setItemConflicts(item, rsrv, itemTypeId);
                    }
                }

                if (itemTypeId === Item.Ids.Resource) {
                    if (
                        item.itemId === parseInt(rsrv.resource_id) &&
                        rsrv.apNoRequest &&
                        S25Util.date.equal(
                            S25Util.date.dropTZString(rsrv.apViolationDate),
                            S25Util.date.dropTZString(rsrv.reservation_start_dt),
                        )
                    ) {
                        item.apRestriction = {
                            startDt: rsrv.apViolationDate,
                            apNoRequest: true,
                            reason: rsrv.apReason,
                        };
                    }

                    if (item.itemId === parseInt(rsrv.itemId)) {
                        const findConfilict = item.checkedObj.conflicts.find(
                            (i: any) =>
                                i.itemId === parseInt(rsrv.itemId) &&
                                i.candidateDate === rsrv.candidateDate &&
                                i.conflictHash == rsrv.conflictHash,
                        );
                        if (!findConfilict) S25ObjectSearchUtil.setItemConflicts(item, rsrv, itemTypeId);
                    }
                }
            });

            if (item.itemTypeId === Item.Ids.Resource) {
                item.itemId = (item as ResourceReservation).resource_id;
                ObjectSearchAvailabilityUtil.processResourceAvailability(item, specificOccs);
                if (item.availability === "Unlimited") {
                    item.quantity = item.availability;
                } else {
                    const getQty = item.availability.split(" / ");
                    item.quantity = parseInt(getQty[0]);
                }
            }

            item.checkedObj.conflicts.sort(S25Util.shallowSortDates("candidateDate", "conflictStart"));
        });

        return accumItems as unknown as CheckedItem[];
    }

    public static setItemConflicts(item: any, rsrv: any, itemTypeId: Item.Ids) {
        item.hasConflicts = true;
        item.checkedObj.availableDatesWithOverrides -= rsrv.isReal ? 1 : 0;
        item.checkedObj.conflictingDates += 1;
        item.checkedObj.conflicts.push({
            conflictRelation: rsrv.conflictRelation,
            conflictHash: rsrv.conflictHash,
            conflictType: rsrv.conflictType,
            conflictName: rsrv.conflictName,
            conflictStart: rsrv.conflictStart,
            conflictEnd: rsrv.conflictEnd,
            conflictShare: rsrv.conflictShare,
            conflictOverride: rsrv.conflictOverride,
            candidateDate: rsrv.candidateDate,
            occUUID: rsrv.occUUID,
            isReal: rsrv.isReal,
            candidateId: rsrv.candidateId,
            conflictId: rsrv.conflictId,
            date: rsrv.candidateDate,
            itemId: item.itemId,
            itemName: item.itemName,
            itemTypeId: itemTypeId,
        });
        item.checkedObj.hasConflicts = item.checkedObj.hasConflicts || rsrv.hasConflicts;
        item.checkedObj.hasRealConflicts = item.checkedObj.hasRealConflicts || rsrv.hasRealConflicts;

        return item;
    }

    public static getButtonLabel(obj: AvailLocationItems | AvailResourceItems) {
        const { hasConflicts, isReqConflict, hasPerm } = this.getConflictFlags(obj);
        const permLabel = hasPerm ? "Reserve" : "Request";

        if (hasConflicts && !isReqConflict) {
            return `${permLabel} Available`;
        }
        return permLabel;
    }

    public static getButtonClass(obj: AvailLocationItems | AvailResourceItems) {
        const { hasConflicts, isReqConflict, hasPerm } = this.getConflictFlags(obj);
        if (hasConflicts || isReqConflict) {
            return "aw-button aw-button--warning";
        } else if (hasPerm) {
            return "aw-button aw-button--success";
        } else {
            return "aw-button aw-button--primary";
        }
    }

    public static getConflictFlags(obj: AvailLocationItems | AvailResourceItems) {
        const hasConflicts = S25Util.toBool(obj?.checkedObj?.hasConflicts ?? obj?.hasConflicts);
        const isReqConflict = this.isRequestConflict(obj);
        const hasPerm = ["C", "F"].includes(obj?.assign_perm ?? "");

        return { hasConflicts, isReqConflict, hasPerm };
    }

    // req_rsrv : a space that has been requested
    // req_block : the space being reserved has a blocked by relationship with a space that has been requested for the same time
    public static isRequestConflict(obj: AvailLocationItems | AvailResourceItems): boolean {
        const conflicts = obj.checkedObj?.conflicts ?? [];
        const hasRequestConflicts = conflicts.some((c: ConflictDefaults) =>
            ["req_rsrv", "req_block"].includes(c.conflictType),
        );
        const hasRsrvBlockConflicts = conflicts.some((c: ConflictDefaults) =>
            ["rsrv", "block"].includes(c.conflictType),
        );
        return hasRequestConflicts && !hasRsrvBlockConflicts;
    }
}

export interface AvailLocationItems extends S25WsSpace, Layout, CheckedObj {
    itemTypeId?: number;
    conflicts: ConflictDefaults[];
    share?: "F" | "T";
    action?: Function;
}
export interface AvailResourceItems extends S25WsResource, CheckedObj {
    allResAvailDateMap?: any;
    itemTypeId?: number;
    apRestriction?: any;
    availability?: number | undefined;
    maxAvailable?: number;
    minAvailable?: number;
    quantity?: number | undefined;
    conflicts: ConflictDefaults[];
}

export interface Layout {
    layout_diagram_type?: string;
    layout_id?: number;
    layout_name?: string;
    layout_setup_tm?: string;
    layout_photo_name?: string;
    layout_description_id?: number;
    layout_photo_glyph?: string;
    layout_instruction?: string;
    layout_diagram_id?: number;
    layout_diagram_glyph?: string;
    default_layout?: "T" | "F";
    layout_photo_id?: number;
    layout_photo_type?: string;
    layout_tdown_tm?: string;
    layout_capacity?: number;
    layout_diagram_name?: string;
    layout_defn_state?: number;
    layout_description?: string;
    layout_instruction_id?: number;
    status?: S25WsNode["status"]; //'mod' | 'est' | 'del' | 'new' ;
    layout_ratio?: number;
}

export interface UrlParams {
    inputParam?: string;
    query?: string;
    criteria?: string;
    include?: string;
    page_size?: string; //&page_size=25
    page?: string; // "&page=1"
    paginate?: string; // "&paginate="
}
